<template>
    <dashboard-layout>
        <div>


            <!--            <div class="row">-->
            <!--&lt;!&ndash;                <div class="col-md-3 mb-2 pt-2"><h6 class="text-muted mb-1">Review questions </h6></div>&ndash;&gt;-->
            <!--                <div class="col mb-2">-->
            <!--                    <div class="input-group">-->
            <!--                        <button class="btn btn-primary" type="submit" @click="getResults"><i class="ti ti-search"></i></button>-->
            <!--                        <input type="text" class="form-control" v-model="q.q" placeholder="Search..." aria-label="Search">-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--&lt;!&ndash;                <div class="mb-0 position-relative col-md-2 mb-2">&ndash;&gt;-->
            <!--&lt;!&ndash;                    <select class="form-select form-control" v-model="q._order_by" @change="getResults">&ndash;&gt;-->
            <!--&lt;!&ndash;                        <option value="date">Sort by date</option>&ndash;&gt;-->
            <!--&lt;!&ndash;                        <option value="lasts">Sort lasts</option>&ndash;&gt;-->
            <!--&lt;!&ndash;                    </select>&ndash;&gt;-->
            <!--&lt;!&ndash;                </div>&ndash;&gt;-->
            <!--            </div>-->

            <!--            <form @submit.prevent="getResults">-->


            <!--                <div class="form-group row">-->
            <!--                    <label class="col-sm-2 col-form-label">الاسم</label>-->
            <!--                    <div class="col-sm-10">-->
            <!--                        <input type="text" class="form-control " v-model="q.name">-->

            <!--                    </div>-->
            <!--                </div>-->


            <!--                <div class="form-group">-->
            <!--                    <button type="submit" class="btn btn-primary">Search</button>-->
            <!--                </div>-->
            <!--            </form>-->

            <h5 class="mt-3 mb-2"> {{ book?.name ?? 'Book Index'}}</h5>


            <div class="tags">
                <router-link
                    :to="{'name' : 'book_chapters.index' , params: { 'subscribe_id': $route?.params?.subscribe_id, 'specialty_id' : item.id }}"
                    class="btn btn-soft-warning" v-for="item in items?.data" :key="item.id">
                    {{ item?.name }}
                </router-link>
            </div>

            <Bootstrap5Pagination
                class="mb-0"
                :data="items"
                :limit="2"
                :show-disabled="false"
                :size="'default'"
                :align="'center'"
                @pagination-change-page="getResults"
            />

        </div>
    </dashboard-layout>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();

export default {
    components: {
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            book: null,
            q: this.$route.query,
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('book_specialties', {
                params: {
                    'page': page,
                    // 'name': this.q.name,
                    'subscribe_id': this.$route?.params?.subscribe_id,
                    'book_id' : this.$route?.params?.book_id,
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                this.book = response.data?.book?.data;

                // this.$router.replace({name: "book_specialties.index", query: {'page': page, 'name': this.q.name}});
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
    }
}
</script>

<style>
.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.badge {
    cursor: pointer;
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: white;
    border-radius: 0.25rem;
}

.badge:hover {
    background-color: #0056b3;
}
</style>
